module.exports = __webpack_public_path__ + "static/media/18_tn.806e815f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/18_tn.jpg
// module id = 327
// module chunks = 0